export interface BannerSponsoring {
  _uid: string;
  isSponsored: boolean;
  advertiserName: string;
  advertiserPayerName: string;
  position: SponsoringPosition;
}

export type SponsoringPosition = typeof SPONSORING_POSITION[keyof typeof SPONSORING_POSITION];

export const SPONSORING_POSITION = {
  bottomLeft: 'bottom-left',
  bottomRight: 'bottom-right',
} as const;
